import { ContractPageData } from '@vy/api-definition';
import { isNotEmptyArray, isNullOrUndefined, Optional } from '@vy/utils';
import { useEffect, useMemo, useRef } from 'react';
import { useContractVersionStateParam } from '../../../../../hooks/requests/use-contract-version';
import { getContractVersions, getCurrentPhaseRevisionId } from '../utils/contract-version-utils';

type UseContractVersionDataParams = {
  contractPageData: ContractPageData;
};

export const useContractVersionData = ({ contractPageData }: UseContractVersionDataParams) => {
  const [versionIdFromUrl, setVersionIdInUrl] = useContractVersionStateParam();
  const contractVersions = useMemo(() => getContractVersions(contractPageData), [contractPageData]);
  const isVersioned = isNotEmptyArray(contractVersions);
  const hasInitializedVersion = useRef(false);

  // Initialize version ID on mount (only once)
  useEffect(() => {
    if (
      contractVersions.length > 0 &&
      isNullOrUndefined(versionIdFromUrl) &&
      !hasInitializedVersion.current
    ) {
      const currentPhaseRevisionId = getCurrentPhaseRevisionId(contractVersions);
      setVersionIdInUrl(currentPhaseRevisionId);
      hasInitializedVersion.current = true;
    }
  }, [contractVersions.length, versionIdFromUrl, setVersionIdInUrl]);

  return {
    versionIdFromUrl: versionIdFromUrl as Optional<string>,
    setVersionIdInUrl: setVersionIdInUrl as (versionId: Optional<string>) => void,
    contractVersions,
    isVersioned,
  };
};
